module.exports = __webpack_public_path__ + "img/logo.20ebd965.png";